// https://github.com/ausi/cq-prolyfill
window.cqApi = require('cq-prolyfill')({
    preprocess: true,
});
